import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export interface ResponseNotificationState {
  id: number,
  type: string,
  message: string,
}

const initialState: ResponseNotificationState[] = [];

export const responseNotificationSlice = createSlice({
  name: 'responseNotification',
  initialState,
  reducers: {
    addToast: (state, action) => {
      return [...state, action.payload];
    },
    deleteToast: (state, action) => {
      const newNotificationArray = state.filter((toast) => toast.id !== action.payload);
      return newNotificationArray;
    },
  },
});

export const { addToast, deleteToast } = responseNotificationSlice.actions;

export const selectResponseNotification = (state: RootState): ResponseNotificationState[] => {
  return [...state.responseNotification]
}

export default responseNotificationSlice.reducer;